import React from 'react'
import { PRODUCT_ACTIONS } from '../../constants'

export const BuyOrUpgradeButton = ({ needRemoveDowngrade, productAction, recurringEnabled }) => {
    return (
        <>
            {needRemoveDowngrade ||
            productAction.type === PRODUCT_ACTIONS.notAvailable ||
            (!recurringEnabled && productAction.type === PRODUCT_ACTIONS.downgrade) ? (
                <div className="subscriptions__action" />
            ) : productAction.action ? (
                <div
                    className={`subscriptions__action subscriptions__action_${productAction.type}`}
                    onClick={productAction.action}
                >
                    {productAction.description}
                </div>
            ) : (
                <div className={`subscriptions__action subscriptions__action_${productAction.type}`}>
                    {productAction.description}
                </div>
            )}
        </>
    )
}
